import { FormattedMessage } from "react-intl";
import AdditionalDetailsIcon from "../../../../components/Common/SvgIcons/AdminIcons/UserManagementIcons/AdditionalDetailsIcon";
import UserDetailsIcon from "../../../../components/Common/SvgIcons/AdminIcons/UserManagementIcons/UserDetailsIcon";
import UserLocationIcon from "../../../../components/Common/SvgIcons/AdminIcons/UserManagementIcons/UserLocationIcon";
import { colors } from "../../../stripeColors";
import { userManagement } from "./userManagement";

export const userManagementForm = {
  name: (location, tenantName) =>
    location?.pathname.includes(userManagement.addUserPath(tenantName)) ? (
      "Add New User"
    ) : (
      <FormattedMessage id="USERMANAGE_EDITUSERPOPUPTITLE" />
    ),
  path: (location, tenantName, userId) =>
    location?.pathname.includes(userManagement.addUserPath(tenantName))
      ? userManagement.addUserPath(tenantName)
      : userManagement.editUserPath(tenantName, userId),
  userDetails: {
    name: "Add User Details",
    path: (location, tenantName, userId) =>
      `${userManagementForm.path(location, tenantName, userId)}/addUserDetails`,
    formFields: (handleNameExists, isLoginIdExistsLoader, isDisabled, domainNameList, setDomainNameList, editPath, customRadio, unregisterDomainName) => [
      {
        key: 1,
        label: <FormattedMessage id="USERMANAGE_LOGINID" />,
        name: "LoginId",
        placeholder: "Enter Login ID",
        labelColor: "light",
        required: true,
        onChange: handleNameExists,
        loading: isLoginIdExistsLoader,
        disabled: isDisabled,
        isVisible: true
      },
      {
        key: 2,
        label: <FormattedMessage id="USERMANAGE_EMAILID" />,
        name: "EmailId",
        placeholder: "Enter Email ID",
        labelColor: "light",
        required: true,
        isVisible: true
      },
      {
        key: 3,
        label: "Domain",
        name: "DomainName",
        fieldName: "Name",
        fieldValue: "Id",
        id: "Id",
        labelColor: "light",
        type: "noSearchTags",
        placeholder: "Select",
        required: true,
        height: "3.9",
        searchTagsList: domainNameList,
        handleTagList: (domain) => setDomainNameList(domain),
        searchable: "true",
        buttonLabel: "Select Domain Name",
        isVisible:
          !customRadio &&
          !editPath &&
          (["saml2", "aad"].includes(
            localStorage.getItem("SecurityProviderName").toLowerCase()
          ) ||
            (localStorage.getItem("SecurityProviderName").toLowerCase() ===
              "custom" &&
              JSON.parse(localStorage.getItem("tenantData") || "{}")?.SAMLConfig
                ?.IdentityType === 2)),
        disabled: localStorage.getItem("SecurityProviderName").toLocaleLowerCase() === "aad"
      },
      {
        key: 4,
        label: <FormattedMessage id="USERMANAGE_FNAME" />,
        name: "FirstName",
        placeholder: "Enter First Name",
        labelColor: "light",
        required: true,
        labelMsg: "(Max : 20 Characters)",
        maxLength: 20,
        isVisible: true
      },
      {
        key: 5,
        label: <FormattedMessage id="USERMANAGE_MNAME" />,
        name: "MiddleName",
        placeholder: "Enter Middle Name",
        labelColor: "light",
        disabled: isDisabled,
        labelMsg: "(Max : 20 Characters)",
        maxLength: 20,
        isVisible: true
      },
      {
        key: 6,
        label: <FormattedMessage id="USERMANAGE_LNAME" />,
        name: "LastName",
        placeholder: "Enter Last Name",
        labelColor: "light",
        required: true,
        labelMsg: "(Max : 20 Characters)",
        maxLength: 20,
        isVisible: true
      },
    ],
  },
  userLocation: {
    name: "Select User Location",
    path: (location, tenantName, userId) =>
      `${userManagementForm.path(
        location,
        tenantName,
        userId
      )}/selectUserLocation`,
    formFields: (formArgs) => [
      {
        key: 1,
        label: <FormattedMessage id="USERMANAGE_COUNTRY" />,
        name: "Country",
        fieldName: "CountryName",
        fieldValue: "Id",
        placeholder: "Select Region/Country",
        labelColor: "light",
        type: "select",
        valueArr: formArgs?.countryList,
        onChange: (e) => formArgs?.handleSelectCountry(e),
        loading: formArgs.getCountryListLoader,
        //   disabled: formArgs.shotclassType === "edit",
      },
      {
        key: 2,
        label: <FormattedMessage id="USERMANAGE_STATE" />,
        name: "State",
        fieldName: "StateName",
        fieldValue: "Id",
        placeholder: "Select State/Province",
        labelColor: "light",
        type: "select",
        valueArr: formArgs?.stateList,
        onChange: (e) => formArgs?.handleSelectState(e),
        loading: formArgs.getStateListLoader,
      },
      {
        key: 3,
        label: <FormattedMessage id="USERMANAGE_CITY" />,
        name: "City",
        fieldName: "CityName",
        fieldValue: "Id",
        placeholder: "Select City",
        labelColor: "light",
        type: "select",
        valueArr: formArgs?.cityList,
        onChange: (e) => formArgs?.handleSelectCity(e),
        loading: formArgs.getCityListLoader,
      },
      {
        key: 4,
        name: "Store",
        label: <FormattedMessage id="DISTRIBUTE_STORE" />,
        labelColor: "light",
        type: "noSearchTags",
        fieldName: "StoreName",
        fieldValue: "StoreId",
        placeholder: "Select",
        height: "5",
        // width: "14.5",
        searchable: "true",
        id: "StoreId",
        searchTagsList: formArgs?.storeList,
        handleTagList: (tagsList) => formArgs?.setStoreList(tagsList),
        loading: formArgs.getWorkOfficeListLoader,
        disabled: false,
      },
    ],
  },
  additionalDetails: {
    name: "Add Additional Details",
    path: (location, tenantName, userId) =>
      `${userManagementForm.path(
        location,
        tenantName,
        userId
      )}/addAdditionalDetails`,
    formFields: (formArgs) => [
      {
        key: 1,
        name: "Category",
        label: <FormattedMessage id="CREATE_CAT_TEXT" />,
        labelColor: "light",
        type: "noSearchTags",
        fieldName: "Name",
        fieldValue: "CategoryId",
        placeholder: "Select",
        height: "5",
        width: "24.5",
        searchTagsList: formArgs?.userDepartmentList,
        handleTagList: (tagsList) => formArgs?.setUserDepartmentList(tagsList),
        isNested: true,
        nestFieldName: "SubCategory",
        loading: formArgs?.getProductCategoryListLoader,
        disabled: false,
        searchable: "true",
      },
      {
        key: 2,
        name: "AssociatedRoles",
        label: <FormattedMessage id="ROLE_TEXT" />,
        labelColor: "light",
        type: "noSearchTags",
        fieldName: "RoleName",
        fieldValue: "RoleID",
        placeholder: "Select",
        height: "5",
        width: "24.5",
        searchTagsList: formArgs?.rolesList,
        handleTagList: (tagsList) => formArgs?.setRolesList(tagsList),
        loading: formArgs?.getAllRolesLoader,
        disabled: formArgs?.isSuperTenant,
        searchable: "true",
      },
      {
        key: 3,
        name: "UserGroupDetails",
        label: <FormattedMessage id="USERMANAGE_USERGROUPDETAILS" />,
        labelColor: "light",
        type: "noSearchTags",
        fieldName: "Name",
        fieldValue: "UserGroupId",
        placeholder: "Select",
        searchable: "true",
        height: "5",
        width: "24.5",
        searchTagsList: formArgs?.userGroupList,
        handleTagList: (tagsList) => formArgs?.setUserGroupList(tagsList),
        loading: formArgs?.getUserGroupsLoader,
        disabled: false,
        labelMsg: "(Max: 20 Groups)",
      },
    ],
  },
  navLinks: (navigate, location, tenantName, userId) => [
    ...userManagement.navLinks(navigate, tenantName),
    {
      key: 3,
      label: userManagementForm.name(location, tenantName),
      path: `${userManagementForm.path(
        location,
        tenantName,
        userId
      )}/addUserDetails`,
      onClick: () =>
        navigate(
          `${userManagementForm.path(
            location,
            tenantName,
            userId
          )}/addUserDetails`
        ),
    },
  ],
  tiles: (navigate, location, tenantName, userId) => [
    {
      key: 1,
      label: userManagementForm.userDetails.name,
      path: userManagementForm.userDetails.path(location, tenantName, userId),
      icon: (fill) => <UserDetailsIcon fill={fill} />,
      color: colors.green,
      isCompleted: false,
      onClick: () =>
        navigate(
          userManagementForm.userDetails.path(location, tenantName, userId)
        ),
    },
    {
      key: 2,
      label: userManagementForm.userLocation.name,
      path: userManagementForm.userLocation.path(location, tenantName, userId),
      icon: (fill) => <UserLocationIcon fill={fill} />,
      color: colors.purple,
      isCompleted: false,
      onClick: () =>
        navigate(
          userManagementForm.userLocation.path(location, tenantName, userId)
        ),
    },
    {
      key: 3,
      label: userManagementForm.additionalDetails.name,
      path: userManagementForm.additionalDetails.path(
        location,
        tenantName,
        userId
      ),
      icon: (fill) => <AdditionalDetailsIcon fill={fill} />,
      color: colors.red,
      isCompleted: false,
      onClick: () =>
        navigate(
          userManagementForm.additionalDetails.path(
            location,
            tenantName,
            userId
          )
        ),
    },
  ],
  formData: {
    FirstName: "",
    MiddleName: "",
    LastName: "",
    LoginId: "",
    Password: "",
    PhoneNo: "",
    EmailId: "",
    ProfileImageUrl: "Profil",
    City: "",
    Country: "",
    State: "",
    Gender: "N/A",
    Store: [],
    Category: [],
    AssociatedRoles: [],
    AADLoginName: "",
    UserGroupDetails: [],
    GenderId: 1,
    IsHybridCustom: false,
    UserGroups: [],
    DomainName: []
  },
};
